import { render, staticRenderFns } from "./BlockListExperts.vue?vue&type=template&id=52e2966f&"
import script from "./BlockListExperts.vue?vue&type=script&lang=js&"
export * from "./BlockListExperts.vue?vue&type=script&lang=js&"
import style0 from "./BlockListExperts.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports